/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getServerTime.defs.js";
export { main as default } from "./getServerTime.defs.js";
